export default "__VITE_ASSET__BOxMMbiz__"